import { DeleteFilled } from '@ant-design/icons';
import React from 'react';
import { Link } from 'react-router-dom';
import '@/assets/style/companyList.scss';

const DeleteModalButton = ({ showCancelModal, data }) => {
  return (
    <div className="ant-button-delete">
      <Link
        size="medium"
        onClick={(e) => {
          showCancelModal(data);
          e.stopPropagation();
        }}
      >
        <DeleteFilled className="delete" />
      </Link>
    </div>
  );
};

export default DeleteModalButton;
